function teamBox(team, winnerId) {
  if (!team) {
    return (
      <div className="px-3 py-2 rounded-md bg-gray-100 dark:bg-gray-800 text-sm opacity-50">
        noch offen
      </div>
    );
  }
  const won = winnerId && team.id === winnerId;
  return (
    <div
      className={`px-3 py-2 rounded-md text-sm border ${
        won
          ? "border-yellow-400 bg-yellow-50 dark:bg-yellow-900/30 font-semibold"
          : "border-gray-200 dark:border-gray-600"
      }`}
    >
      {team.name}
    </div>
  );
}

function MatchCard({ match }) {
  return (
    <div className={`min-w-[180px] rounded-xl border p-2 bg-white dark:bg-gray-800 ${match.mine ? "border-emerald-500" : "border-gray-200 dark:border-gray-600"}`}>
      {teamBox(match.home, match.winnerId)}
      <div className="text-center text-xs py-1 opacity-70">
        {match.status === "bye"
          ? "Freilos"
          : match.score
            ? match.score
            : match.status === "scheduled"
              ? "steht an"
              : "—"}
      </div>
      {teamBox(match.away, match.winnerId)}
    </div>
  );
}

const TournamentBracket = ({ bracket, championName }) => {
  if (!bracket?.rounds?.length) {
    return <p className="opacity-70">Der Turnierbaum wird gelost, sobald das Starterfeld steht.</p>;
  }
  return (
    <div className="space-y-4">
      <div className="overflow-x-auto pb-2">
        <div className="flex gap-8 min-w-max items-stretch">
          {bracket.rounds.map((round) => (
            <div key={round.key} className="flex flex-col min-w-[200px]">
              <h3 className="font-bold mb-3 text-center">{round.name}</h3>
              <div className="flex flex-col justify-around gap-6 flex-1">
                {round.matches.map((match) => (
                  <MatchCard key={`${round.key}-${match.slot}`} match={match} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      {bracket.third ? (
        <div>
          <h3 className="font-bold mb-2">{bracket.thirdName || "Spiel um Platz 3"}</h3>
          <MatchCard match={bracket.third} />
        </div>
      ) : null}
      {championName ? (
        <p className="text-lg font-semibold">🏆 Champion: {championName}</p>
      ) : null}
    </div>
  );
};

export default TournamentBracket;
